enum FilterTypeEnum {
  REJECT_TITLE = 'REJECT_TITLE',
  REJECT_NUMBER = 'REJECT_NUMBER',
  LIKELY_TITLE = 'LIKELY_TITLE',
}

export default FilterTypeEnum;
